import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutUs from '../components/AboutUs';
import ServicesOverview from '../components/ServicesOverview';
import Subsidiaries from '../components/Subsidiaries';
import ContactUs from '../components/ContactUs';
import NewsUpdates from '../components/NewsUpdates';
import gardamorImg from '../images/GardamorISP.png';
import baniuagaImg from '../images/Baniuagagroup.jpg';
import gardamorUnipImg from '../images/Gardamorunp.jpg';
import roziFuelImg from '../images/Rozi Fuel.jpg';
import roziTourImg from '../images/Rozi tour and travel.jpg';

const HomePage = () => {
  return (
    <>
      <HeroSection 
        headline="Welcome to Baniuaga Group"
        subheadline="Contributing to the sustainable development of Timor-Leste through focused business excellence and market-leading subsidiaries"
        ctaButtonText="Learn More"
        ctaButtonLink="#about"
      />
      <AboutUs 
        title="About Baniuaga Group"
        imageUrl={baniuagaImg}
      />
      <ServicesOverview 
        title="Our Services"
        description="Baniuaga Group manages and controls diverse subsidiaries across multiple sectors, ensuring sustainable development and superior returns for stakeholders in Timor-Leste."
      />
      <Subsidiaries 
        title="Companies"
        subsidiaries={[
          {
            name: 'Gardamor Unip. Lda',
            description: 'Professional security services since 2007, providing comprehensive safety solutions to government institutions, international organizations, embassies, private sectors, and residential clients.',
            link: '#gardamor-unip',
            logoPlaceholder: gardamorUnipImg
          },
          {
            name: 'Gardamor ISP Lda',
            description: 'Officially authorized internet service provider delivering high-performance connectivity solutions to government institutions, international organizations, embassies, NGOs, and private sector clients throughout Timor-Leste.',
            link: 'https://gardamorisp.com',
            logoPlaceholder: gardamorImg
          },
          {
            name: 'Rozi Tour and Travel Unip. Lda',
            description: 'Complete travel solutions including itinerary planning, tour arrangements, ticketing services, accommodation bookings, and comprehensive travel coordination for business and leisure travelers.',
            link: '#rozi-tours',
            logoPlaceholder: roziTourImg
          },
          {
            name: 'Rozi Fuel Unip. Lda',
            description: 'Comprehensive retail fuel services for all vehicle types, serving diverse customers including corporate fleets and providing dedicated fuel supply solutions for Baniuaga Group operations.',
            link: '#rozi-fuel',
            logoPlaceholder: roziFuelImg
          },
          {
            name: 'Rozi Construction Unip. Lda',
            description: 'Professional construction and development services building modern infrastructure for Timor-Leste\'s future.',
            link: '#rozi-construction',
            logoPlaceholder: baniuagaImg
          }
        ]}
      />
      <NewsUpdates />
      <ContactUs 
        title="Contact Us"
        introText="Have questions or want to learn more about Baniuaga Group? We'd love to hear from you."
        phoneNumber="+670 7739 9991"
        email="info@baniuagaholding.com"
        address="Avenida Presidente Nicolao Lobato no. 159, Fatuhada, Dili, Timor-Leste"
      />
    </>
  );
};

export default HomePage;